import React, { useEffect, useMemo, useState } from "react";
import axios from "../../utils/axiosConfig";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import DealNavigation from "../../components/DealNavigation";
import BuyerDetailModal from "../../components/BuyerDetailModal";
import ShipperDetailModal from "../../components/ShipperDetailModal";
import FollowupModal from "../../components/FollowupModal";
import FixationModal from "../../components/FixationModal";
import DealInfoPanel from "../../components/DealInfoPanel";
import { buildFixationPricingDefaults } from "../../utils/fixationDefaults";
const SalesContract = () => {
  const navigate = useNavigate();
  const { dealId } = useParams();

  const [deal, setDeal] = useState({});
  const [loading, setLoading] = useState(false);
  const [showDealInfo, setShowDealInfo] = useState(true);
  const [showBuyer, setShowBuyer] = useState(false);
  const [showShipper, setShowShipper] = useState(false);
  const [showFollowup, setShowFollowup] = useState(false);
  const [showFixation, setShowFixation] = useState(false);
  const fixationPricingDefaults = useMemo(() => buildFixationPricingDefaults(deal), [deal]);
  const [formData, setFormData] = useState({
    scNo: "",
    receiveDate: ""
  });

  useEffect(() => {
    if (dealId) {
      fetchDeal();
    }
  }, [dealId]);

  const fetchDeal = async () => {

    try {

      const res = await axios.get(`/container-release/deal/${dealId}`);

      setDeal(res.data);

      setFormData({
        scNo: res.data.SCRNo || "",
        receiveDate: res.data.SCRDate ? res.data.SCRDate.split("T")[0] : ""
      });

    }
    catch (err) {
      console.error(err);
    }

  };
  const handleSave = async () => {

    if (!formData.scNo || !formData.receiveDate) {
      alert("SC No and Receive Date required");
      return;
    }

    try {

      const response = await axios.post("/sales-contract/save", {
        dealId,
        scNo: formData.scNo,
        receiveDate: formData.receiveDate
      });

      alert("Sales Contract saved successfully");
      if (Number(response.data?.nextStage) === 3) {
        navigate(`/transaction/advance-payment/${dealId}`);
      } else {
        navigate(`/transaction/shipment-schedule/${dealId}`);
      }

    }
    catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Error saving sales contract");
    }

  };
  if (loading) return <div className="p-3">Loading...</div>;

  return (
     <>
            <DealNavigation
                dealId={dealId}
                openBuyer={() => setShowBuyer(true)}
                openShipper={() => setShowShipper(true)}
                openFixation={() => setShowFixation(true)}
                openFollowup={() => setShowFollowup(true)}
            />
    <div className="container-fluid mt-3">

      {/* ===== HEADER BADGE ===== */}
      <div className="mb-2">
        <span className="badge bg-success fs-6 px-3 py-2">
          Sales Contract
        </span>
      </div>


      <DealInfoPanel
        deal={deal}
        show={showDealInfo}
        onToggle={() => setShowDealInfo(!showDealInfo)}
      />

      {/* ================= VIEW DEAL INFO ================= */}
      <div className="border rounded bg-white mb-3 d-none">

        <div
          className="px-3 py-2 border-bottom fw-bold text-muted d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => setShowDealInfo(!showDealInfo)}
        >
          View Deal Info
          <span>{showDealInfo ? "▲" : "▼"}</span>
        </div>

        {showDealInfo && (
          <div className="p-3">

            <div className="row mb-2">

              <div className="col-md-4 d-flex">
                <label className="fw-bold me-2">Deal No-Date :</label>
                <input
                  type="text"
                  className="form-control form-control-sm w-auto"
                  value={`${deal.DealID || ""} - ${deal.DealDate?.split("T")[0] || ""}`}
                  disabled
                />
              </div>

              <div className="col-md-4 d-flex">
                <label className="fw-bold me-2">Buyer Name :</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={deal.BuyerName || ""}
                  disabled
                />
              </div>

              <div className="col-md-4 d-flex">
                <label className="fw-bold me-2">Shipper Name :</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={deal.ShipperName || ""}
                  disabled
                />
              </div>

            </div>

          </div>
        )}

      </div>


      {/* ================= SALES CONTRACT FORM ================= */}
      <div className="border rounded p-4 bg-white mb-3">

        <div className="row justify-content-center g-3">

          <div className="col-md-4">
            <label className="form-label fw-bold">SC No *</label>
            <input
              type="text"
              className="form-control form-control-sm"
              value={formData.scNo}
              onChange={(e) =>
                setFormData({ ...formData, scNo: e.target.value })
              }
            />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-bold">Receive Date *</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={formData.receiveDate}
              onChange={(e) =>
                setFormData({ ...formData, receiveDate: e.target.value })
              }
            />
          </div>

        </div>

      </div>


      {/* ================= ACTION BUTTONS ================= */}
      <div className="text-center mb-4">
        <button
          className="btn btn-success btn-sm me-2"
          onClick={handleSave}
        >
          Save
        </button>

        <button className="btn btn-secondary btn-sm">
          Cancel
        </button>
      </div>

    </div>
     <BuyerDetailModal
                    show={showBuyer}
                    dealId={dealId}
                    onClose={() => setShowBuyer(false)}
                />
                <ShipperDetailModal
                    show={showShipper}
                    dealId={dealId}
                    onClose={() => setShowShipper(false)}
                />
                <FixationModal
                    show={showFixation}
                    dealId={dealId}
                    totalQty={deal.TotalQty}
                    dealCurrency={deal.DealCurrency}
                    dealPricingDefaults={fixationPricingDefaults}
                    onClose={() => setShowFixation(false)}
                />
                <FollowupModal
                    show={showFollowup}
                    dealId={dealId}
                    onClose={() => setShowFollowup(false)}
                />
            </>
  );
};

export default SalesContract;
